// **React Imports
import React, { forwardRef, memo } from 'react'

// **MUI Imports
import { Box } from '@mui/material'

// **Third party Imports
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'

// **Styles Imports
import './index.scss'

const MarkdownRenderer = forwardRef(
  ({ value, className = '', rendererStyle = {} }, ref) => {
    const customRenderers = {
      img: ({ src, alt, title }) => {
        const width = title?.includes('width=')
          ? title.split('width=')[1].replace('px', '')
          : '500'
        return (
          <img
            src={src}
            alt={alt}
            style={{
              width: `${width}px`,
              height: 'auto',
              maxWidth: '100%'
            }}
          />
        )
      }
    }

    return (
      <Box
        className={`markdown-body ${className}`}
        ref={ref}
        sx={{ ...rendererStyle }}
      >
        <ReactMarkdown components={customRenderers} remarkPlugins={gfm}>
          {value}
        </ReactMarkdown>
      </Box>
    )
  }
)

export default memo(MarkdownRenderer)
